import React, { useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useHistory } from "react-router-dom";

import "./Sidebar.styles.scss";
// import ForwardArrow from "../../../Assets/forward-arrow.svg";
// import Resources from "../../../../stylesheets/Resources.scss";
// import design from "../../../Assets/design-0.svg";
// import design2 from "../../../Assets/design-2.svg";
import logs from "../../../Assets/logs.svg";
import dashboard from "../../../Assets/dashboard.svg";
import team from "../../../Assets/team.svg";
import download from "../../../Assets/download.svg";
import howtodevelop from "../../../Assets/howtodevelop.svg";
import companylogo from "../../../Assets/organization/profile.png";
import ConsoleLocalStorage from "../../../storage/storage";
import ComingSoonModal from "../modal/ComingSoonModal";
import { useGetOrg } from "../../../hooks/DevConsoleHooks";
import { sliceString } from "../../../util/helpers/funcHelper";
import discordIcon from "../../../Assets/discordIcon.png";
import { Badge } from "react-bootstrap";
import { useAllProjects } from "../../../hooks/DevProjectHooks";
import { projectStatus } from "../../../util/helpers/statusHelper";
const Sidebar = ({ children }) => {
  /**
   * Org data
   */
  const { data: org } = useGetOrg(ConsoleLocalStorage.getOrganization()?.id);
  const [showComingSoon, setShowComingSoon] = useState(false);
  const [discordAccess, setDiscordAccess] = useState();
  const [discordJoined, setDiscordJoined] = useState(
    ConsoleLocalStorage.getDiscordJoined
  );
  const { data: projects } = useAllProjects();

  useEffect(() => {
    checkDiscordAccess();
  });

  const checkDiscordAccess = () => {
    setDiscordAccess(
      projects?.some((item) => item.status === projectStatus.approved.status)
    );
  };

  return (
    <React.Fragment>
      <div className="sidebar">
        <ComingSoonModal
          showComingSoon={showComingSoon}
          setShowComingSoon={setShowComingSoon}
        />
        <div className="sidebar_logo_wrapper">
          <NavLink
            exact
            activeClassName="active"
            to={"/console/organization-dashboard"}
            // onClick={() => history.push("organization-dashboard")}
            className="sidebar_logo"
          >
            <img
              alt="logo"
              style={{ borderRadius: "50%" }}
              src={org?.logo ? org.logo : companylogo}
            ></img>
            <h2 className="">
              {sliceString(
                0,
                30,
                ConsoleLocalStorage.getOrganization()?.name,
                true
              )}{" "}
            </h2>
          </NavLink>
        </div>
        <ul className="sidebar_list_primary">
          <li className="">
            <NavLink exact activeClassName="active" to={"/console/"}>
              <img src={dashboard} alt="logo" className="sidebar_card_img" />
              Dashboard
            </NavLink>
          </li>
          <li className="">
            <NavLink to={"/console/team"}>
              <img src={team} alt="logo" className="sidebar_card_img" />
              My Team
            </NavLink>
          </li>
          <li className="" onClick={() => setShowComingSoon(true)}>
            <a>
              <img src={logs} alt="logo" className="sidebar_card_img" />
              Activity Logs
            </a>
          </li>
        </ul>
        <div className="sidebar_middle"></div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
            height: "58vh",
          }}
          className=""
        >
          <div className="">{children}</div>
          <div className="sidebar_lowerhalf">
            <ul className="">
              <li className="">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href="https://docs.tesseract.in"
                >
                  <img
                    src={howtodevelop}
                    alt="logo"
                    className="sidebar_card_img"
                  />
                  How to Develop?
                </a>
              </li>
              {discordAccess && (
                <li>
                  <NavLink
                    to={"/join-discord"}
                    style={{
                      backgroundColor: !discordJoined ? "#4096EF" : null,
                    }}
                  >
                    <img src={discordIcon} alt="discordIcon" />
                    {!discordJoined ? (
                      <>
                        <span className="text-white font-size-12 theme__font--medium mlc-5">
                          Join JioGlass Discord Server
                        </span>
                        <Badge
                          pill
                          bg="primary"
                          style={{ marginTop: "-5px", marginLeft: "-2px" }}
                        >
                          New
                        </Badge>
                      </>
                    ) : (
                      <span className="text-white font-size-12 theme__font--medium mlc-5">
                        Access JioGlass Discord Server
                      </span>
                    )}
                  </NavLink>
                </li>
              )}

              <li>
                <NavLink to="/downloads">
                  <img src={download} alt="logo" className="sidebar_card_img" />
                  Downloads
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Sidebar;
